import style from "../../../assets/scss/common/header.module.scss";
import expandedIcon from "../../../assets/images/header/expanded_icon.svg";
import collapsedIcon from "../../../assets/images/header/collapsed_icon.svg";
import {CouponVoucherStatus} from "../CouponVoucherStatus";
import {UserDetail} from "../../../types/user";
import React from "react";
import {HeaderLinkField} from "../../HeaderLinkField";
import {useUserAgent} from "../../../hooks/hooks";
import {useTranslation} from "react-i18next";

interface Args {
    user: UserDetail | undefined,
    couponCount: number,
    organVoucherCount: number,
    consultingVoucherCount: number,
    organDcasVoucherCount: number,
    userVoucherCount: number,
    isCouponVoucherCollapsed: boolean,
    setIsCouponVoucherCollapsed: (_: boolean) => void,
    couponVoucherOptionsRef: React.Ref<any>,
    onClickLogoutBtn: (_: React.MouseEvent) => void
}

export function LoggedInStatusBar(
    {
        user,
        couponCount,
        organVoucherCount,
        consultingVoucherCount,
        organDcasVoucherCount,
        userVoucherCount,
        isCouponVoucherCollapsed,
        setIsCouponVoucherCollapsed,
        couponVoucherOptionsRef,
        onClickLogoutBtn
    }: Args) {
    const { t } = useTranslation("loginBar");
    const {isDesktop, isTablet} = useUserAgent();

    // 사용자 이름 컴포넌트 추출
    const UserName = () => (
        <span className={style.userName}>
      <span className={style.accent}>{user?.name}</span> {t("loggedIn.sir")}
    </span>
    );

    // 쿠폰/바우처 상태 컴포넌트 추출
    const CouponVoucherStatusComponent = () => (
        <CouponVoucherStatus
            couponCount={couponCount}
            organVoucherCount={organVoucherCount}
            consultingVoucherCount={consultingVoucherCount}
            organDcasVoucherCount={organDcasVoucherCount}
            userVoucherCount={userVoucherCount}
        />
    );

    // 모바일 쿠폰/바우처 토글 버튼 컴포넌트 추출
    const VoucherCouponToggle = () => (
        <div className={style.voucherCouponButtonWrapper}>
            <button
                className={style.voucherCouponButton}
                onClick={(e) => {
                    e.stopPropagation();
                    setIsCouponVoucherCollapsed(!isCouponVoucherCollapsed);
                }}
            >
                <span>{t('loggedIn.couponAndVoucher')}</span>
                <img
                    src={isCouponVoucherCollapsed ? collapsedIcon : expandedIcon}
                    alt={"펼침 아이콘"}
                />
            </button>
            {!isCouponVoucherCollapsed && (
                <div ref={couponVoucherOptionsRef}>
                    <CouponVoucherStatusComponent/>
                </div>
            )}
        </div>
    );

    return (
        <>
            {isDesktop ? (
                <div className={style.loginBar}>
                    <HeaderLinkField/>

                    <div className={style.innerBar}>
                        <div className={style.loggedInStatus}>
                            <CouponVoucherStatusComponent/>
                            <UserName/>
                            <button className={style.logoutBtn} onClick={onClickLogoutBtn}>
                                {t("btn.logout")}
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={style.loginBar}>
                    <div className={style.innerBar}>
                        <div className={style.loggedInStatus}>
                            <div className={style.myInfoWrapper}>
                                <div className={style.myInfoArea}>
                                    <UserName/>
                                    <VoucherCouponToggle/>
                                </div>
                                {isTablet && (
                                    <HeaderLinkField/>
                                )}
                            </div>

                            <button className={style.logoutBtn} onClick={onClickLogoutBtn}>
                                {t("btn.logout")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}